import { render, staticRenderFns } from "./PedidosConfirmados2.vue?vue&type=template&id=4e8d221e"
import script from "./PedidosConfirmados2.vue?vue&type=script&lang=js"
export * from "./PedidosConfirmados2.vue?vue&type=script&lang=js"
import style0 from "./PedidosConfirmados2.vue?vue&type=style&index=0&id=4e8d221e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports